import React, {useCallback, useEffect, useState} from 'react';
import {useIntl} from 'react-intl';

import {useCategoryContext} from 'brand/app/pages/category/context/CategoryContext';
import {useGeneralProvider} from 'brandComponents/_app-config/GeneralProvider';

import messages from './messages';

import styles from './InTheMoodForToggle.module.scss';

const InTheMoodForToggle = () => {
	const {managerRepository} = useGeneralProvider();
	const intl = useIntl();
	const {isITMF, showITMFBanner, setShowITMFBanner} = useCategoryContext(true) || {};
	const [isChecked, setIsChecked] = useState(isITMF && showITMFBanner);

	const onClick = useCallback((e) => {
		if (!isChecked) {
			e.preventDefault();
			managerRepository.getFlyoutsMgr().openFlyout('inTheMoodFor', true);
			setShowITMFBanner(false);
		}
	}, [isChecked]);

	const onChange = useCallback((e) => {
		setIsChecked(e.target.checked);
		setShowITMFBanner(e.target.checked);
	}, []);

	useEffect(() => {
		setIsChecked(isITMF && showITMFBanner);
	}, [isITMF, showITMFBanner]);

	return (
		<div className={styles['itmf-toggle__wrapper']} onClick={onClick}>
			<label className={styles['toggle-wrapper']}>
				<input type="checkbox" id="mood-toggle" checked={isChecked} onChange={onChange} readOnly/>
				<span className={styles['toggle-slider']}></span>
			</label>
			<label htmlFor="mood-toggle">{intl.formatMessage(messages.inTheMoodFor)}</label>
		</div>
	);
};

export default InTheMoodForToggle;
